import { RoleMap } from '@/models/config';

export interface NavItem {
    id: string,
    name: string,
    link: string,
    children?: Array<any>,
    subIcons?: Array<{
        id: string,
        show: boolean,
    }>
}

export const NAVIGATION_LIST: Array<NavItem> = [
    {
        id: 'video-upload',
        name: '上传视频',
        link: 'https://cp.kuaishou.com/article/publish/video?origin=www.kuaishou.com',
    },
    {
        id: 'recharge',
        name: '快币充值',
        link: 'https://pay.ssl.kuaishou.com/pay',
    },
    {
        id: 'tv',
        name: 'TV端',
        link: '/ott',
        subIcons: [
            {
                id: 'new-tv-version',
                show: false,
            },
        ],
    },
];

export const NAVUSER_LIST = [
    {
        id: 'myFollow',
        name: '我的关注',
        link: '/myFollow',
        logName: '我的关注按钮',
        className: 'my-follow',
        role: RoleMap.Like,
    },
    {
        id: 'creator',
        name: '创作者中心',
        link: 'https://cp.kuaishou.com/profile',
        logName: '创作者中心',
        className: 'creator',
    },
];